import React from "react";
import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemTmdbBtnV2 from "../../../shared/itemTmdbBtnV2/itemTmdbBtnV2";
import UseSquadflixNavigate from "../useSquadflixNavigate";
import SquadflixRowTitle from "../squadflixRowTitle/squadflixRowTitle";
import {useTrendingMoviesData} from "../../hooks/useCatalogRowData";

type Props = SquadflixRowsBaseProps & {
    onMovieClick?: (item: any) => void;
}

const TrendingMoviesRow = (props: Props) => {
    const {onMovieClick} = props;
    const {movies: tmdbTrendingMovies, loading} = useTrendingMoviesData();
    const squadflixNav = UseSquadflixNavigate({});

    if (loading) return null;
    if (!tmdbTrendingMovies || tmdbTrendingMovies.length === 0) return null;
    return (
        <div style={{height: "275px", overflow: "hidden", order: props.order ?? 0}}>
            <SquadflixRowTitle
                {...props}
                icon={<i className="fa-solid fa-chart-simple"></i>}
                title="Tendencias: Pelis"/>
            <ItemsHorizontalScroll>
                {tmdbTrendingMovies.map((item) => (
                    <ItemTmdbBtnV2
                        key={item.id}
                        onClick={() => onMovieClick ? onMovieClick(item) : squadflixNav.navigateToMovie(item)}
                        bottomInfo={<>{item.vote_average.toFixed(1)}<i
                            className="fa-solid fa-star text-warning fa-sm ps-1"></i></>}
                        tmdbItem={item}
                        type="movie"
                        description={item.release_date}
                    />
                ))}
            </ItemsHorizontalScroll>
        </div>
    );
};

export default TrendingMoviesRow;
